import { z } from 'zod';
import { SystemSchema } from '../../entities/system/system.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Update System Request Schema
 * PATCH /api/v2/systems/:id
 */ export const UpdateSystemRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    description: z.string().optional(),
    systemOwner: z.string().optional(),
    category: z.string().optional(),
    url: z.string().optional(),
    licenceSeats: z.number().int().min(0).optional()
});
/**
 * Update System Response Schema
 * PATCH /api/v2/systems/:id
 */ export const UpdateSystemResponseSchema = z.object({
    data: SystemSchema
});

//# sourceMappingURL=update-system.schema.js.map